'use strict';

module.exports = function (str) {
  var match = str.match(/^[ \t]*(?=\S)/gm);

  if (!match) {
    return str;
  } // TODO: use spread operator when targeting Node.js 6


  var indent = Math.min.apply(Math, match.map(function (x) {
    return x.length;
  })); // eslint-disable-line

  var re = new RegExp("^[ \\t]{".concat(indent, "}"), 'gm');
  return indent > 0 ? str.replace(re, '') : str;
};